import * as ActionTypes from 'constants/ActionTypes';

import objectAssign from 'object-assign';
const initialState = {
  hasConnection: false,
};

export default function jaws(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.JAWS_SET_INSTANCE:
      return objectAssign({}, state, { instance: action.instance });

    case ActionTypes.JAWS_CONNECTION_ESTABLISHED:
      return objectAssign({}, state, { hasConnection: true });

    case ActionTypes.JAWS_CONNECTION_CLOSED:
      return objectAssign({}, state, { hasConnection: false });

    default:
      return state;
  }
}
